<script>import AdaptiveImage from "../components/AdaptiveImage.svelte";
import { attrValue } from "../../utils/html";
import ProgressIndicator from "./ProgressIndicator.svelte";
import IconLottie from "./IconLottie.svelte";
import { AccountStateEnum } from "../../enums";
export let initials;
export let imageUrl = null;
export let alt = null;
export let size = "default";
export let border = "solid";
export let classNames = null;
export let showStatus = false;
export let state;
export let isFetching;
let iconSize, initialsFontSize, initialsBorderStyle, stateClassNames, stateIconName, ref;
const getIconSize = () => {
  size === "big" && (iconSize = "default");
  size === "default" && (iconSize = "small");
  size === "small" && (iconSize = "tiny");
  return iconSize;
};
const getInitialsFontSize = () => {
  size === "big" && (initialsFontSize = "text-xl");
  size === "default" && (initialsFontSize = "");
  size === "small" && (initialsFontSize = "text-xs");
  return initialsFontSize;
};
const getInitialsBorderStyle = () => {
  border === "none" && (initialsBorderStyle = "border-none");
  border === "hidden" && (initialsBorderStyle = "border-hidden");
  border === "double" && (initialsBorderStyle = "border-double");
  border === "dashed" && (initialsBorderStyle = "border-dashed");
  border === "solid" && (initialsBorderStyle = "border");
  return initialsBorderStyle;
};
$: if (state === AccountStateEnum.CHECKED) {
  stateClassNames = "bg-success-light text-success";
  stateIconName = "check";
} else if (state === AccountStateEnum.PENDING) {
  stateClassNames = "bg-grey-lighter text-grey-dark";
  stateIconName = "clock";
} else if (state === AccountStateEnum.WARNING) {
  stateClassNames = "bg-warning-light text-warning";
  stateIconName = "warning";
} else if (state === AccountStateEnum.ERROR) {
  stateClassNames = "bg-error-light text-error";
  stateIconName = "error";
}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
	class={attrValue([size, classNames, 'avatar relative flex-shrink-0'])}
	on:click
	bind:this={ref}
>
	{#if isFetching}
		<div class="w-full h-full flex items-center justify-center">
			<ProgressIndicator />
		</div>
	{:else}
		<div
			class="overflow-hidden rounded-full {getInitialsBorderStyle()}  border-2 border-white h-full {!imageUrl &&
			initials
				? 'bg-text flex justify-center items-center'
				: ''}"
		>
			{#if imageUrl}
				<AdaptiveImage src={imageUrl} classNames="object-cover w-full h-full" {alt} />
			{:else if !imageUrl && initials}
				<div class="uppercase text-white {getInitialsFontSize()}">
					{initials}
				</div>
			{/if}
		</div>
		{#if showStatus}
			<div
				class="absolute -right-2 bottom-0 {stateClassNames} rounded-full p-1 {getInitialsBorderStyle()} border-white"
			>
				<IconLottie name={stateIconName} size={getIconSize()} parentRef={ref} />
			</div>
		{/if}
	{/if}
</div>

<style>.small{height:2rem;width:2rem}.big,.default{height:3rem;width:3rem}@media (min-width:768px){.big{height:7rem;width:7rem}}.huge{height:14rem;width:14rem}</style>
